module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "amap-wrapper-show"
  }, [_c('el-amap', {
    staticClass: "amap-box",
    attrs: {
      "plugin": _vm.plugin,
      "vid": "map",
      "zoom": _vm.zoom,
      "center": _vm.center,
      "events": _vm.events
    }
  }, _vm._l((_vm.markers), function(item) {
    return _c('el-amap-marker', {
      key: item.id,
      staticClass: "amap-marker",
      attrs: {
        "position": item.position,
        "vid": "marker",
        "title": item.title,
        "label": item.label,
        "offset": _vm.offset
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32601701","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/DataTablePage/amapShow.vue
// module id = 1731
// module chunks = 1